/** Formato de cifras para la interfaz. Punto decimal en los dos idiomas, igual que el motor:
 *  así una cifra de la respuesta y la misma cifra de una tabla se leen idénticas. */
export function num(v: number | null | undefined, dec = 1): string {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  if (Number.isInteger(v) && Math.abs(v) < 1e4 && dec <= 1) return String(v);
  return v.toFixed(dec);
}

export function eur(v: number | null | undefined): string {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  const a = Math.abs(v);
  if (a >= 1e6) return `€ ${(v / 1e6).toFixed(2)} M`;
  if (a >= 1e3) return `€ ${(v / 1e3).toFixed(0)} k`;
  return `€ ${v.toFixed(0)}`;
}

export function usd(v: number): string {
  if (!v) return "$0";
  return v < 0.01 ? `$${v.toFixed(4)}` : `$${v.toFixed(3)}`;
}

export function ms(v: number): string {
  return v >= 1000 ? `${(v / 1000).toFixed(1)} s` : `${v} ms`;
}

/** Una celda de tabla puede traer un bilingüe, una lista o un objeto anidado. */
export function celda(valor: unknown, idioma: "es" | "en"): string {
  if (valor === null || valor === undefined || valor === "") return "—";
  if (typeof valor === "boolean") return valor ? "✓" : "—";
  if (typeof valor === "number") return num(valor, Number.isInteger(valor) ? 0 : 2);
  if (typeof valor === "string") return valor;
  if (Array.isArray(valor)) return valor.map((v) => celda(v, idioma)).join(", ");
  if (typeof valor === "object") {
    const o = valor as Record<string, unknown>;
    // Un par vacío (un SKU sin atributos afectados) se lee como celda vacía, no como blanco.
    if ("es" in o || "en" in o) return String(o[idioma] ?? o.en ?? o.es ?? "") || "—";
    return Object.entries(o).slice(0, 3).map(([k, v]) => `${k}: ${celda(v, idioma)}`).join("; ");
  }
  return String(valor);
}

/** La cifra principal de una tarjeta, con el formato que su UNIDAD pide.
 *  Sin esto, un impacto en ventas netas se leía «2049352 €» en vez de «€ 2.05 M». */
export function cifra(valor: number, unidad: string): string {
  if (unidad === "€") return eur(valor);
  if (unidad === "%") return num(valor, Math.abs(valor) < 10 ? 2 : 1);
  if (unidad === "r" || unidad === "Cpk" || unidad === "score" || unidad === "tolerancias") return num(valor, 2);
  return num(valor, Math.abs(valor) < 100 ? 2 : 0);
}
